import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardSkeleton = React.memo(() => {
  return (
    <div className="card">
      <div style={{ height: "212px" }}>
        <Skeleton height="100%" />
      </div>
      <div className="card-body">
        <Skeleton height={20} width="80%" className="mb-2 mt-2" />
        <Skeleton height={16} width="60%" className="mb-1" />
        <Skeleton height={16} width="40%" className="mb-2" />
        <div className="d-flex gap-2 mb-2">
          <Skeleton height={24} width={60} />
          <Skeleton height={24} width={80} />
        </div>
        <Skeleton height={14} width="90%" count={3} />
      </div>
      <div className="card-footer bg-transparent border-1">
        <div className="card-footer-content d-flex justify-content-between align-items-center">
          <Skeleton height={16} width={60} />
          <Skeleton height={32} width={100} />
        </div>
      </div>
    </div>
  );
});

export default CardSkeleton;
